import ca from "./ca";
import es from "./es";

export default {
  ca,
  es,
};
